import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, Typography, Button, Dialog, CircularProgress } from "@mui/material";

export default function ButtonComponent({
  label,
  loadingLabel,
  onClick,
  disabled = false,
  buttonSx = {},
  loading = false,
  buttonColor = 'primary',         // warna tombol (MUI color prop)
  spinnerColor = 'primary.main',   // warna spinner
  textColor = 'white'              // warna teks
}) {
  return (
    <Box sx={{ position: 'relative' }}>
      <Button
        variant="contained"
        color={buttonColor}
        sx={{
          color: textColor,
          ...buttonSx
        }}
        disabled={loading || disabled}
        onClick={onClick}
      >
        {loading ? loadingLabel : label}
      </Button>
      {loading && (
        <CircularProgress
          size={24}
          sx={{
            color: spinnerColor,
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-12px',
            marginLeft: '-12px',
          }}
        />
      )}
    </Box>
  );
}

  